import React, { useState } from "react";
import { Power } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { userApiService } from "../services/userApiService";

/**
 * Shown when device supports a pump but none is marked connected.
 * Toggle enables PumpControl + irrigation editors (actions still use popups).
 */
export default function PumpConnectPrompt({ deviceId, canEdit, onChanged }) {
  const [busy, setBusy] = useState(false);

  const markConnected = async () => {
    if (!canEdit) {
      toast.warning("You do not have permission to change pump settings.");
      return;
    }
    setBusy(true);
    try {
      await userApiService.updateDevice(deviceId, { pumpConnected: true });
      toast.success("Pump marked as connected");
      onChanged?.();
    } catch (error) {
      toast.error(error?.message || "Could not update");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-2xl border border-dashed border-border bg-cream/20 p-4">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-muted p-2">
          <Power className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium">Pump not connected</div>
          <p className="mt-1 text-xs text-muted-foreground">
            Motor / pump controls and irrigation schedules stay hidden until you connect a pump to this device.
          </p>
          {canEdit && (
            <Button className="mt-3" size="sm" variant="outline" disabled={busy} onClick={markConnected}>
              I connected a pump
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
